angular.module('umCore').constant('advancedFilterType', {
    ACCOUNT_GRID: 'accountGrid',
    ACCOUNT_SUBMISSIONS_GRID: 'accountSubmissionsGrid',
    POLICY_GRID: 'policyGrid',
    SUBMISSION_GRID: 'submissionGrid',
    ACTIVITY_GRID: 'activityGrid',
    TASK_GRID: 'taskGrid',
    FORM_TEMPLATE_BROWSER: 'formTemplateBrowser',
    DATA_SET_BROWSER: 'dataSetBrowser',
    RULES_BROWSER: 'rulesBrowser',
    PRODUCT_TEMPLATE_BROWSER: 'productTemplateBrowser',
    ORGANIZATION_BROWSER: 'organizationBrowser'
});
